import apiClient from 'api/base';
import { pick } from 'lodash';
import type { TComment } from 'models/task-comment.model';

export const getTaskComments = async (id: string): Promise<TComment[]> => {
  const { data } = await apiClient.get(`/task/${id}/comments`);

  return data;
};

export const createTaskComment = async (
  taskId: string,
  comment: TComment,
): Promise<TComment> => {
  const strippedComment = pick(comment, ['value']);
  const { data } = await apiClient.post(
    `/task/${taskId}/comments`,
    strippedComment,
  );

  return data;
};

export const deleteTaskComment = async (
  commentId: string,
): Promise<TComment> => {
  const { data } = await apiClient.delete(`/comments/${commentId}`);

  return data;
};

export const updateTaskComment = async (
  comment: TComment,
): Promise<TComment> => {
  const strippedComment = pick(comment, ['value']);
  const { data } = await apiClient.put(
    `/comments/${comment.id}`,
    strippedComment,
  );

  return data;
};

// Broadcast Comments API
export const getBroadcastComments = async (id: string): Promise<TComment[]> => {
  const { data } = await apiClient.get(`/broadcast/${id}/comments`);

  return data;
};

export const createBroadcastComment = async (
  broadcastId: string,
  comment: TComment,
): Promise<TComment> => {
  const strippedComment = pick(comment, ['value']);
  const { data } = await apiClient.post(
    `/broadcast/${broadcastId}/comments`,
    strippedComment,
  );

  return data;
};

export const deleteBroadcastComment = async (
  commentId: string,
): Promise<TComment> => {
  const { data } = await apiClient.delete(`/comments/${commentId}`);

  return data;
};

export const updateBroadcastComment = async (
  comment: TComment,
): Promise<TComment> => {
  const strippedComment = pick(comment, ['value']);
  const { data } = await apiClient.put(
    `/comments/${comment.id}`,
    strippedComment,
  );

  return data;
};
